<template>
    <div>
        <rkm-area
            no-margin-top
            title="Filtros"
            type="fieldset"
        >
            <rkm-form
                ref="Form"
                show-legend
            >
                <rkm-row>
                    <rkm-col cols="4">
                        <rkm-form-date-picker
                            range
                            :range-inline="false"
                            start-label="Período de"
                            end-label="Até"
                            v-model="model.periodo"
                            :start-validations="validations.periodo.start"
                            :end-validations="validations.periodo.end"
                        />
                    </rkm-col>

                    <rkm-col cols="4">
                        <rkm-form-select
                            defaultOptionText="Todas"
                            :options="unidadesSolicitante"
                            label="Unidade solicitante"
                            show-default-option
                            text-field="unidadeSolicitanteNome"
                            v-model="model.unidadeSolicitanteId"
                            value-field="unidadeSolicitanteId"
                        />
                    </rkm-col>

                    <rkm-col cols="4">
                        <rkm-form-select
                            defaultOptionText="Todas"
                            :options="unidades"
                            label="Unidade executante"
                            show-default-option
                            text-field="unidadeNome"
                            v-model="model.unidadeId"
                            value-field="unidadeId"
                            :validations="validations.unidadeId"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="4">
                        <rkm-form-select
                            :options="exames"
                            defaultOptionText="Todos"
                            label="Exames"
                            show-default-option
                            text-field="exameNome"
                            v-model="model.exameId"
                            value-field="exameId"
                        />
                    </rkm-col>

                    <rkm-col cols="4">
                        <rkm-form-select
                            :options="status"
                            defaultOptionText="Todos"
                            label="Status"
                            show-default-option
                            text-field="statusNome"
                            v-model="model.statusId"
                            value-field="statusId"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <rkm-form-input
                            label="Prontuário"
                            v-model="model.prontuario"
                            number
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <rkm-form-input
                            label="Código procedimento"
                            v-model="model.procedimento"
                            number
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="8">
                        <rkm-form-input-autocomplete
                            :repository="repositories.paciente"
                            :search-fields="fieldsPaciente.paciente"
                            :text-field="(item) => item.cidadao.nome"
                            label="Paciente"
                            v-model="model.paciente"
                            uppercase
                        />
                    </rkm-col>

                    <rkm-col>
                        <rkm-form-select
                            label="Grupo de exames"
                            :options="data.form.grupos"
                            v-model="model.grupoId"
                            show-default-option
                            default-option-text="Todos"
                            text-field="nome"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col>
                        <rkm-button
                            :label="false"
                            color="primary"
                            class="float-left"
                            @click="$refs.Form.validate(search)"
                        >
                            Buscar
                        </rkm-button>

                        <rkm-button
                            :label="false"
                            @click="resetForm()"
                            class="mr-2 float-left"
                        >
                            Limpar
                        </rkm-button>
                    </rkm-col>
                </rkm-row>
            </rkm-form>
        </rkm-area>

        <rkm-area
            title="Totais"
            type="fieldset"
            no-margin-top
            v-if="notSaveLancamentos"
        >
            <rkm-row>
                <rkm-col cols="2">
                    Paciente
                    <rkm-alert color="secondary">
                        <strong>
                            {{ totalPaciente() }}
                        </strong>
                    </rkm-alert>
                </rkm-col>

                <rkm-col cols="2">
                    Exame
                    <rkm-alert color="secondary">
                        <strong>
                            {{ totalExames() }}
                        </strong>
                    </rkm-alert>
                </rkm-col>
            </rkm-row>
        </rkm-area>

        <rkm-area
            v-if="notSaveLancamentos"
            no-margin-top
            title="Resultado"
        >
            <template v-slot:trailing>
                <rkm-dropdown
                    class="mr-2"
                    color="primary"
                    no-caret
                    small
                    title="Colunas"
                    cols="1"
                    v-rkm-tooltip.hover
                    menu-class="auto-scroll"
                >
                    <template v-slot:button-content>
                        <rkm-icon icon="columns" />
                    </template>

                    <rkm-form-checkbox
                        @change="handleSelectedColumns"
                        :indeterminate="indeterminate"
                        class="mx-2"
                    >
                        Todas
                    </rkm-form-checkbox>

                    <rkm-form-checkbox-group
                        :options="cols"
                        class="mx-2"
                        v-model="selectedCols"
                    />
                </rkm-dropdown>

                <rkm-button
                    :disabled="notSaveLancamentos.length === 0"
                    @click="impressao()"
                    color="info"
                    small
                    title="Imprimir"
                >
                    <rkm-icon icon="print" />
                </rkm-button>

                <rkm-button
                    :disabled="notSaveLancamentos.length === 0"
                    @click="exportar()"
                    color="info"
                    small
                    title="Exportar"
                >
                    <rkm-icon icon="file-export" />
                </rkm-button>
            </template>

            <rkm-table
                :items="notSaveLancamentos"
                :fields="fields"
                ref="Table"
                sort-by="data"
                hide-filters
            >
                <template v-slot:cell(pacienteNome)="row">
                    <rkm-button
                        class="mr-2"
                        color="secondary"
                        small
                        v-rkm-popover.hover.left="
                            {
                                title: 'Dados cadastrais',
                                html: true,
                                content:
                                    '<b>Prontuário:</b> ' + (row.item.prontuario || '') + '<br/>' +
                                    '<b>Data de Nascimento:</b> ' + row.item.dataNascimento + '<br/>' +
                                    '<b>Nome da Mãe:</b> ' + row.item.nomeMae + '<br/>'
                            }
                        "
                    >
                        <rkm-icon icon="user" />
                    </rkm-button>

                    <span v-if="!row.item.sequencialDesconhecido">
                        {{row.item.pacienteNome}}
                    </span>

                    <span
                        v-else
                        class="text-primary"
                        v-rkm-popover.hover.top="
                            {
                                title: 'Características físicas',
                                content: row.item.caracteristicasFisicas
                            }
                        "
                    >
                        {{row.item.pacienteNome}}
                    </span>
                </template>

                <template v-slot:cell(nomeProcedimento)="row">
                    <template v-if="row.item.nomeProcedimento === null || row.item.nomeProcedimento === ''|| row.item.nomeProcedimento === 0">
                       SEM PROCEDIMENTO
                    </template>
                    <template v-else>
                        {{ row.item.nomeProcedimento }}
                    </template>
                </template>

                <template v-slot:cell(exameCodigo)="row">
                    <template v-if="row.item.exameCodigo === null || row.item.exameCodigo === ''|| row.item.exameCodigo === 0">
                        -
                    </template>
                    <template v-else>
                        {{ row.item.exameCodigo }}
                    </template>
                </template>
            </rkm-table>
        </rkm-area>
    </div>
</template>

<script>

// Mixins.
import { repository, error, object, data, stringCase, file} from '@/mixins'

// Enuns.
import statusFechamento from '@/enums/exame-imagem/fechamento/status'

// Vuex.
import { mapActions } from 'vuex'

// Moment.
import moment from 'moment'

export default {
    created() {

        this.repositories = {
            impressao: this.getConectaSusRepository('impressao.exameImagem'),
            exportacao: this.getConectaSusRepository('exportacao.exameImagem'),
            paciente: this.getConectaSusRepository('cadastro.sujeitoAtencao.paciente'),
            relatorio: this.getConectaSusRepository('exameImagem.relatorioExameStatus'),
        }
        this.load()
    },
    computed: {
        fields() {
            let fields = [
                { key: 'data', label: 'Data', sortable: true },
                { key: 'pacienteNome', label: 'Paciente', sortable: true },
                { key: 'prontuario', label: 'Prontuário', sortable: true },
                { key: 'exameNome', label: 'Exame', sortable: true },
                { key: 'statusNome', label: 'Status', sortable: true},
            ]

            this.selectedCols.map(map => {

                const col = this.cols.find(find => find.value === map)
                fields.push({ key: col.value, label: col.text, sortable: true })
            })

            return fields
        },
        fieldsPaciente(){

            return {
                paciente: [
                    { key: 'cidadao.nome', searchable: true },
                ],
            }
        },
         validations() {
            return {
                periodo: {
                    start: { required: true },
                    end: { required: true },
                }
            }
        },
        unidadesSolicitante(){

            let unidadeSolicitanteOrigem = []

            if(this.model.periodo.start && this.model.periodo.end){

                this.resetUnidadesSolicitante()
                this.resetDatatable()

                const start = moment(this.model.periodo.start).subtract(1, 'day')
                const end = moment(this.model.periodo.end).add(1, 'day')

                this.data.model.relatorioExameStatus.filter(agendamento =>
                    moment(agendamento.data, 'DD/MM/YYYY').isBetween(start, end))
                        .map(unidade => {

                            let verifyUnidade = unidadeSolicitanteOrigem.find(u => u.unidadeSolicitanteId === unidade.unidadeSolicitanteId)

                            if(!verifyUnidade){

                                unidadeSolicitanteOrigem.push({

                                    unidadeSolicitanteId: unidade.unidadeSolicitanteId,
                                    unidadeSolicitanteNome: unidade.unidadeSolicitanteNome
                                })
                            } else {

                                this.resetUnidadesSolicitante()
                                this.resetDatatable()
                            }
                        })
            }

            return unidadeSolicitanteOrigem
        },
        unidades(){

            let unidadeOrigem = []

            if(this.model.periodo.start && this.model.periodo.end){

                this.resetUnidade()
                this.resetDatatable()

                const start = moment(this.model.periodo.start).subtract(1, 'day')
                const end = moment(this.model.periodo.end).add(1, 'day')

                this.data.model.relatorioExameStatus.filter(agendamento =>
                    moment(agendamento.data, 'DD/MM/YYYY').isBetween(start, end)
                        && agendamento.unidadeSolicitanteId === this.model.unidadeSolicitanteId)
                            .map(unidade => {

                                let verifyUnidade = unidadeOrigem.find(u => u.unidadeId === unidade.unidadeId)

                                if(!verifyUnidade){

                                    unidadeOrigem.push({

                                        unidadeId: unidade.unidadeId,
                                        unidadeNome: unidade.nomeFantasia
                                    })
                                } else {

                                    this.resetUnidade()
                                    this.resetDatatable()
                                }
                            })
            }

            return unidadeOrigem
        },
        exames(){

            let exameOrigem = []

            if(this.model.periodo.start && this.model.periodo.end){

                this.resetExames()
                this.resetDatatable()

                const start = moment(this.model.periodo.start).subtract(1, 'day')
                const end = moment(this.model.periodo.end).add(1, 'day')

                if(this.verificaUnidade == true){

                    this.data.model.relatorioExameStatus.filter(e => moment(e.data, 'DD/MM/YYYY').isBetween(start, end)
                        && e.unidadeSolicitanteId === this.model.unidadeSolicitanteId && e.unidadeId === this.model.unidadeId)
                            .map(exame => {

                                if (exameOrigem) {

                                    let verifyExame = exameOrigem.find(u => u.exameId === exame.exameId)

                                    if (!verifyExame) {

                                        exameOrigem.push({

                                            exameId: exame.exameId,
                                            exameNome: exame.exameNome,
                                        })
                                    } else {

                                        this.resetExames()
                                        this.resetDatatable()
                                    }
                                }
                            })

                    exameOrigem.sort((a,b) => (a.exameNome > b.exameNome) ? 1 : ((b.exameNome > a.exameNome) ? -1 : 0));

                } else {

                    this.data.model.relatorioExameStatus.filter(e => moment(e.data, 'DD/MM/YYYY').isBetween(start, end)
                        && e.unidadeSolicitanteId === this.model.unidadeSolicitanteId)
                            .map(exame => {

                                if (exameOrigem) {

                                    let verifyExame = exameOrigem.find(u => u.exameId === exame.exameId)

                                    if (!verifyExame) {

                                        exameOrigem.push({

                                            exameId: exame.exameId,
                                            exameNome: exame.exameNome,
                                        })
                                    } else {

                                        this.resetExames()
                                    }
                                }
                            })

                    exameOrigem.sort((a,b) => (a.exameNome > b.exameNome) ? 1 : ((b.exameNome > a.exameNome) ? -1 : 0));
                }
            }

            return exameOrigem
        },
        status(){

            let statusOrigem = []

            if(this.model.periodo.start && this.model.periodo.end){

                this.resetStatus()
                this.resetDatatable()

                const start = moment(this.model.periodo.start).subtract(1, 'day')
                const end = moment(this.model.periodo.end).add(1, 'day')

                if(this.verificaExame == true){

                    this.data.model.relatorioExameStatus.filter(s =>
                        moment(s.data, 'DD/MM/YYYY').isBetween(start, end)
                            && s.unidadeSolicitanteId === this.model.unidadeSolicitanteId && s.exameId === this.model.exameId)
                                .map(status => {

                                    if(status.statusId == null){

                                        status.statusId = this.enums.statusFechamento.AGENDADO
                                    }

                                    let verifyStatus = statusOrigem.find(u => u.statusId === status.statusId)

                                    if(!verifyStatus){

                                        statusOrigem.push({

                                            statusId: status.statusId,
                                            statusNome: status.statusNome
                                        })
                                    } else {

                                        this.resetStatus()
                                        this.resetDatatable()
                                    }
                                })

                        statusOrigem.sort((a,b) => (a.statusNome > b.statusNome) ? 1 : ((b.statusNome > a.statusNome) ? -1 : 0));

                } else {

                    this.data.model.relatorioExameStatus.filter(e => moment(e.data, 'DD/MM/YYYY').isBetween(start, end)
                        && e.unidadeSolicitanteId === this.model.unidadeSolicitanteId).forEach(status => {

                            if(status.statusId == null){

                                status.statusId = this.enums.statusFechamento.AGENDADO
                            }

                            if (statusOrigem) {
                                let verifyStatus = statusOrigem.find(u => u.statusId === status.statusId);

                                if (!verifyStatus) {

                                    if (!statusOrigem.some(s => s.statusNome === status.statusNome)) {
                                        statusOrigem.push({
                                            statusId: status.statusId,
                                            statusNome: status.statusNome,
                                        });
                                    }
                                } else {
                                    this.resetExames();
                                }
                            }
                        });

                    statusOrigem.sort((a, b) => (a.statusNome > b.statusNome) ? 1 : ((b.statusNome > a.statusNome) ? -1 : 0));
                }
            }

            return statusOrigem
        }
    },
    data: () => ({
        notSaveLancamentos: null,
        model: {
            prontuario: '',
            periodo: {
                start: null,
                end: null,
            },
            paciente: null,
            exameId: null,
            unidadeId: null,
            unidadeSolicitanteId: null,
            statusId: null,
            procedimento: '',
            grupoId: null
        },
        indeterminate: false,
        additionals: {},
        enums:{
            statusFechamento,
        },
        selectedCols: [],
        cols: [
            { value: 'codigoNomeProcedimento', text: 'Procedimento', },
            { value: 'unidadeSolicitanteNome', text: 'Unidade solicitante', },
            { value: 'nomeFantasia', text: 'Unidade executante', },
            { value: 'nomeAgendador', text: 'Usuário da solicitação', },
            { value: 'dataHoraSolicitacao', text: 'Data/hora solicitação', },
            { value: 'grupo', text: 'Grupo', },
        ],
        verificaUnidade: false,
        verificaExame: false,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {
            this.model.periodo.start = this.data.model.periodo.start
            this.model.periodo.end = this.data.model.periodo.end
        },
        search() {

            this.setLoading()

            this.repositories.relatorio.datatable(this.getSearchParams())
                .then(({ data }) => {

                    this.notSaveLancamentos = data
                    this.handleSelectedColumns()
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        setDefaultValues() {
            this.model.periodo.start = this.data.model.periodo.start
            this.model.periodo.end = this.data.model.periodo.end
            this.resetDatatable()
        },
        getSearchParams() {
            const params = this.clone(this.model)
            this.formateDates(params.periodo, ['start', 'end'], 'DD/MM/YYYY')
            return this.camelObjectKeysToSnakeRecursive(params)
        },
        resetDatatable(){
            this.notSaveLancamentos = null
            this.model.paciente = null
            this.model.statusId = null
            this.model.procedimento = null
            this.model.exame = null
            this.model.prontuario = null
        },
        resetUnidade(){
            this.model.unidadeId = null
        },
        resetUnidadesSolicitante(){
            this.model.unidadeSolicitanteId = null
        },
        resetExames(){
            this.model.exameId = null
        },
        resetStatus(){
            this.model.statusId = null
        },
        resetForm() {

            this.model.prontuario =  null
            this.model.paciente = null
            this.model.exame =  null
            this.model.dataNascimento = null
            this.model.unidadeId = null
            this.model.unidadeSolicitanteId = null
            this.model.statusId = null
            this.model.procedimento = null

            this.$nextTick()
                .then(() => {

                    this.setDefaultValues()
                    this.$refs.Form.resetValidator()
                })
        },
        handleSelectedColumns(selected) {
            if (selected) {
                this.cols.map(col => {

                    this.selectedCols.push(col.value)
                })
            } else {
                this.selectedCols = []
            }
        },
        impressao() {

            this.setLoading()

            const filter = this.getFilterExportPrint()

            filter.columns = this.fields

            this.repositories.impressao.relatorioExameStatus(filter)
                .then(response => {

                    const content = new Blob([response.data], {type: response.headers['content-type']})
                    const url = URL.createObjectURL(content)
                    const link = document.createElement('a')
                    link.href = url
                    link.target = '_blank'
                    link.click()
                    link.remove()
                })
                .finally(() => this.unsetLoading())
        },
        exportar() {

            this.setLoading()

            const filter = this.getFilterExportPrint()
            filter.columns = this.fields

            this.repositories.exportacao.exportExameStatus(filter)
                .then(response => {

                    const content = new Blob([response.data], {type: response.headers['content-type']})
                    const url = URL.createObjectURL(content)
                    const link = document.createElement('a')

                    link.href = url
                    link.target = '_blank'
                    link.click()
                    link.remove()
                })
                .finally(() => this.unsetLoading())
        },
        getFilterExportPrint() {

            const filter = this.getSearchParams()

            const $this = this

            const cols = this.fields.map(function (field) {

                field.key = $this.camelToSnake(field.key)

                return field
            })

            filter.columns = cols

            const somaPaciente = [...new Set(this.notSaveLancamentos.map(item => item.pacienteId))].length
            filter.totalizandoPaciente = somaPaciente

            const somaExames = this.notSaveLancamentos.filter(item => item.exameId).length
            filter.totalizandoExames = somaExames

            const solicitantes = this.data.form.unidadesSolicitantes.find(u => u.id === this.model.unidadeSolicitanteId)
            filter.solicitantes = solicitantes ? solicitantes.nomeFantasia : 'Todas'

            const executantes = this.data.form.unidadesExecutantes.find(u => u.id === this.model.unidadeId)
            filter.executantes = executantes ? executantes.nomeFantasia : 'Todas'

            const exame = this.data.form.exames.find(e => e.id === this.model.exameId)
            filter.exame = exame ? exame.nome : 'Todos'

            const status = this.data.form.status.find(e => e.id === this.model.statusId)
            filter.status = status ? status.nome : 'Todos'

            const grupo = this.data.form.grupos.find(e => e.id === this.model.grupoId)
            filter.grupo = grupo ? grupo.nome : 'Todos'

            return filter
        },
        totalPaciente(){
            return  [...new Set(this.notSaveLancamentos.map(item => item.pacienteId))].length
        },
        totalExames(){
            return this.notSaveLancamentos.filter(item => item.exameId).length
        }
    },
    mixins: [repository, error, object, data, stringCase, file],
    watch: {
        'selectedCols': function (newValue) {

            this.indeterminate = false

            if (newValue.length > 0 && newValue.length != this.cols.length) {

                this.indeterminate = true
            }
        },
        'model.unidadeId': function(){

            if(this.model.unidadeId == null || this.model.unidadeId == ''){

                this.verificaUnidade = false

            } else {

                this.verificaUnidade = true
            }
        },
        'model.exameId': function(){

            if(this.model.exameId == null || this.model.exameId == ''){

                this.verificaExame = false

            } else {

                this.verificaExame = true
            }
        }
    },
    props: {
        data: { type: Object, required: true }
    }
}
</script>

<style scoped>
    .warning {
        color: var(--warning);
    }
</style>